/**
 * Tells the streak widget that something worth crediting just happened.
 *
 * The credits themselves are minted server-side by scanning existing comments,
 * reactions and recognitions — this event carries no data and grants nothing.
 * It exists purely so the widget re-reads its state immediately and the flame
 * flares while you're still looking at it, instead of on the next page load.
 *
 * Fire-and-forget on purpose: if a caller forgets to fire it, the streak is
 * still correct, just not animated until the next fetch.
 */
export const ENGAGEMENT_EVENT = "engagement:action";

export function notifyEngagement(kind) {
  try {
    window.dispatchEvent(
      new CustomEvent(ENGAGEMENT_EVENT, { detail: { kind } })
    );
  } catch {
    /* SSR or a locked-down environment — the widget refreshes on next load */
  }
}
